// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2OhK6","buttons":"RemoveExpirationActionButtons_buttons__ixXnA"};